export default function (value) {
    const [colorName, colorValue] = value.split('#');
    return {
        colorName,
        colorValue: `#${colorValue}`,
    };
}
